<template>
  <header class="app-header-mobile">
    <div class="header-inner">
      <slot></slot>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.app-header-mobile {
  position: sticky;
  top: 0;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #F3F4F6;
  z-index: 11;

  .header-inner {
    padding: 20px 16px;
  }
}
</style>
